module.exports = __webpack_public_path__ + "img/air_state_2.a25e73c6.png";